/*
 * Componentes de la landing, portados 1:1 de los <script> de referencia/landing-maestra.html.
 * Cambios respecto del original (registrados en documentos/correcciones-funcionales.md):
 *  - Cada componente trabaja dentro de su sección (sin ids globales) y puede destruirse/reiniciarse
 *    con los eventos del editor de Shopify (ver ebl-editor.js).
 *  - Valores fijos del original (velocidades, retrasos, umbrales, cantidades) llegan por data-*,
 *    con el valor original como predeterminado.
 *  - El contador del banner usa una fecha de oferta configurable en vez de "25 minutos desde que se abre".
 */
(function () {
  if (!window.EBL) return;
  function num(el, attr, def) { var v = parseFloat(el.getAttribute(attr)); return isNaN(v) ? def : v; }
  function activo(el, attr) { return el.getAttribute(attr) !== 'false'; }

  /* 1. Banner superior: día de la semana + cuenta regresiva a la fecha de oferta. */
  EBL.registrar('contador', {
    init: function (el) {
      var dias = []; try { dias = JSON.parse(el.getAttribute('data-dias') || '[]'); } catch (e) {}
      var modo = el.getAttribute('data-modo') || 'fecha';
      var zona = num(el, 'data-zona-min', -180); // minutos respecto de UTC (Argentina = -180)
      var fin = Date.parse(el.getAttribute('data-fin') || '');
      var alTerminar = el.getAttribute('data-al-terminar') || 'ceros';
      var dayEl = el.querySelector('[data-ebl-dia]');
      var h = el.querySelector('[data-ebl-h]'), m = el.querySelector('[data-ebl-m]'), s = el.querySelector('[data-ebl-s]');
      var cd = el.querySelector('[data-ebl-cd]');
      function finActual(now) {
        if (modo === 'diaria') {
          var local = now + zona * 60000;           // "reloj de pared" en la zona configurada
          var d = new Date(local); d.setUTCHours(24, 0, 0, 0);
          return d.getTime() - zona * 60000;
        }
        return fin;
      }
      var lastDay = new Date().getDay();
      if (dayEl && dias[lastDay]) dayEl.textContent = dias[lastDay];
      function tick() {
        var now = Date.now();
        var end = finActual(now);
        var remaining = isNaN(end) ? 0 : Math.max(0, Math.floor((end - now) / 1000));
        var hh = Math.floor(remaining / 3600), mm = Math.floor((remaining % 3600) / 60), ss = remaining % 60;
        if (h) h.textContent = String(hh).padStart(2, '0');
        if (m) m.textContent = String(mm).padStart(2, '0');
        if (s) s.textContent = String(ss).padStart(2, '0');
        if (cd && alTerminar === 'ocultar') el.classList.toggle('ebl-cd-terminado', remaining === 0);
        var dow = new Date().getDay();
        if (dow !== lastDay) { lastDay = dow; if (dayEl && dias[dow]) dayEl.textContent = dias[dow]; }
      }
      tick();
      el.__eblTimer = setInterval(tick, 1000);
    },
    destroy: function (el) { clearInterval(el.__eblTimer); }
  });

  /* 3. Filtro "Es para vos si…": íconos que se dibujan en cascada al entrar en pantalla. */
  EBL.registrar('filtro', {
    init: function (section) {
      var paths = section.querySelectorAll('.check-path');
      if (!activo(section, 'data-animar')) { paths.forEach(function (p) { p.classList.add('animate'); }); return; }
      var stagger = num(section, 'data-stagger', 150);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            paths.forEach(function (path, i) { setTimeout(function () { path.classList.add('animate'); }, i * stagger); });
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(section);
      section.__eblObs = observer;
    },
    destroy: function (section) { if (section.__eblObs) section.__eblObs.disconnect(); }
  });

  /* 4. Galería animada de dos filas: fila 1 hacia la derecha, fila 2 hacia la izquierda. */
  EBL.registrar('galeria', {
    init: function (el) {
      var track1 = el.querySelector('[data-ebl-track="1"]');
      var track2 = el.querySelector('[data-ebl-track="2"]');
      if (!track1 || !track2 || !activo(el, 'data-animar')) return;
      var GAP = num(el, 'data-gap', 14);
      var CARD_WIDTH = num(el, 'data-card', 190);
      var isMobile = window.innerWidth <= 768;
      var SPEED = isMobile ? num(el, 'data-vel-movil', 0.6) : num(el, 'data-vel-escritorio', 0.4);
      var SET1 = (CARD_WIDTH + GAP) * num(track1, 'data-n', 5);
      var SET2 = (CARD_WIDTH + GAP) * num(track2, 'data-n', 5);
      var x1 = -SET1;
      var x2 = 0;
      function step() {
        x1 += SPEED;
        x2 -= SPEED;
        if (x1 >= 0) x1 = -SET1;
        if (x2 <= -SET2) x2 = 0;
        track1.style.transform = 'translate3d(' + x1 + 'px, 0, 0)';
        track2.style.transform = 'translate3d(' + x2 + 'px, 0, 0)';
        el.__eblRaf = requestAnimationFrame(step);
      }
      step();
    },
    destroy: function (el) { cancelAnimationFrame(el.__eblRaf); }
  });

  /* 5. Beneficios: etiqueta que entra desde la izquierda al ver cada tarjeta. */
  EBL.registrar('beneficios', {
    init: function (section) {
      var cards = section.querySelectorAll('.aaf-learn-card');
      if (!activo(section, 'data-animar')) {
        cards.forEach(function (c) { var l = c.querySelector('.aaf-learn-label'); if (l) l.classList.add('visible'); });
        return;
      }
      var delay = num(section, 'data-retraso', 150);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var label = entry.target.querySelector('.aaf-learn-label');
            if (label) { setTimeout(function () { label.classList.add('visible'); }, delay); }
          }
        });
      }, { threshold: 0.4 });
      cards.forEach(function (card) { observer.observe(card); });
      section.__eblObs = observer;
    },
    destroy: function (section) { if (section.__eblObs) section.__eblObs.disconnect(); }
  });

  /* 6. Estructura del contenido: contador del total. */
  EBL.registrar('contador-total', {
    init: function (el) {
      var obj = el.querySelector('[data-ebl-total]');
      if (!obj) return;
      var target = num(obj, 'data-ebl-total', 200);
      var duration = num(el, 'data-duracion', 2500);
      if (!activo(el, 'data-animar')) { obj.innerHTML = target; return; }
      var summaryCount = obj.closest('.aaf-summary-count');
      function animateCounter() {
        var startTimestamp = null;
        var easeOutExpo = function (t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); };
        var step = function (timestamp) {
          if (!startTimestamp) startTimestamp = timestamp;
          var elapsed = timestamp - startTimestamp;
          var progress = Math.min(elapsed / duration, 1);
          var easedProgress = easeOutExpo(progress);
          obj.innerHTML = Math.floor(easedProgress * target);
          if (progress < 1) {
            el.__eblRaf = window.requestAnimationFrame(step);
          } else {
            obj.innerHTML = target;
            summaryCount.style.transition = 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
            summaryCount.style.transform = 'scale(1.15)';
            setTimeout(function () { summaryCount.style.transform = 'scale(1)'; }, 250);
          }
        };
        el.__eblRaf = window.requestAnimationFrame(step);
      }
      var target_ = el.querySelector('.aaf-pack-final-summary');
      if (!target_) return;
      var triggered = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !triggered) { triggered = true; animateCounter(); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.3 });
      observer.observe(target_);
      el.__eblObs = observer;
      var rect = target_.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0 && !triggered) {
        triggered = true; animateCounter(); observer.unobserve(target_);
      }
    },
    destroy: function (el) { if (el.__eblObs) el.__eblObs.disconnect(); cancelAnimationFrame(el.__eblRaf); }
  });

  /* 8. Carrusel principal de reseñas: cinta continua hacia la izquierda. */
  EBL.registrar('carrusel-resenas', {
    init: function (el) {
      var track = el.querySelector('.aaf-rv2-track');
      if (!track || !activo(el, 'data-animar')) return;
      var GAP = num(el, 'data-gap', 14);
      var isMobile = window.innerWidth <= 768;
      var SPEED = isMobile ? num(el, 'data-vel-movil', 0.6) : num(el, 'data-vel-escritorio', 0.4);
      var origCards = Array.from(track.children);
      origCards.forEach(function (card) {
        var c = card.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-ebl-clon', '');
        c.removeAttribute('data-shopify-editor-block');
        track.appendChild(c);
      });
      var oneSetWidth = origCards.reduce(function (acc, card) { return acc + card.offsetWidth + GAP; }, 0);
      var x = 0;
      function step() {
        x += SPEED;
        if (x >= oneSetWidth) x -= oneSetWidth;
        track.style.transform = 'translate3d(-' + x + 'px, 0, 0)';
        el.__eblRaf = requestAnimationFrame(step);
      }
      step();
    },
    destroy: function (el) {
      cancelAnimationFrame(el.__eblRaf);
      el.querySelectorAll('[data-ebl-clon]').forEach(function (c) { c.remove(); });
    }
  });

  /* 15. Presentación del proyecto: cifras que cuentan hasta su valor. */
  EBL.registrar('cifras', {
    init: function (section) {
      var counters = section.querySelectorAll('.aaf-counter');
      var fmt = function (n) { return n >= 1000 ? n.toLocaleString('de-DE') : n; };
      if (!activo(section, 'data-animar')) { counters.forEach(function (c) { c.innerText = fmt(+c.getAttribute('data-target')); }); return; }
      var duration = num(section, 'data-duracion', 800);
      var startCounters = function () {
        counters.forEach(function (counter) {
          var target = +counter.getAttribute('data-target');
          var frameDuration = 1000 / 60;
          var totalFrames = Math.round(duration / frameDuration);
          var frame = 0;
          var animate = function () {
            frame++;
            var progress = frame / totalFrames;
            var currentCount = Math.round(target * (1 - Math.pow(1 - progress, 3)));
            if (frame <= totalFrames) {
              counter.innerText = fmt(currentCount);
              requestAnimationFrame(animate);
            } else {
              counter.innerText = fmt(target);
            }
          };
          requestAnimationFrame(animate);
        });
      };
      var recordsEl = section.querySelector('.aaf-about-records');
      if (!recordsEl) return;
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { startCounters(); observer.unobserve(entries[0].target); }
      }, { threshold: 0.2 });
      observer.observe(recordsEl);
      section.__eblObs = observer;
    },
    destroy: function (section) { if (section.__eblObs) section.__eblObs.disconnect(); }
  });

  /* 16. FAQ: acordeón (una abierta por vez), con teclado y selección desde el editor. */
  function toggleFaq(item) {
    var wasOpen = item.classList.contains('open');
    var grid = item.parentElement;
    grid.querySelectorAll('.aaf-faq-item').forEach(function (el) {
      el.classList.remove('open');
      var s = el.querySelector('.aaf-faq-summary'); if (s) s.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('open');
      var s = item.querySelector('.aaf-faq-summary'); if (s) s.setAttribute('aria-expanded', 'true');
    }
  }
  EBL.registrar('faq', {
    init: function (el) {
      el.__eblClick = function (ev) {
        var summary = ev.target.closest('.aaf-faq-item');
        if (summary && el.contains(summary)) toggleFaq(summary);
      };
      el.__eblKey = function (ev) {
        if ((ev.key === 'Enter' || ev.key === ' ') && ev.target.classList.contains('aaf-faq-summary')) {
          ev.preventDefault(); toggleFaq(ev.target.closest('.aaf-faq-item'));
        }
      };
      el.addEventListener('click', el.__eblClick);
      el.addEventListener('keydown', el.__eblKey);
    },
    destroy: function (el) { el.removeEventListener('click', el.__eblClick); el.removeEventListener('keydown', el.__eblKey); },
    select: function (el, blockEl) {
      var item = blockEl.closest('.aaf-faq-item');
      if (item && !item.classList.contains('open')) toggleFaq(item);
    }
  });

  /* Popup de ventas recientes: solo con ventas o calificaciones reales cargadas como bloques; apagado por defecto. */
  EBL.registrar('popup-ventas', {
    init: function (popup) {
      var sales = []; try { sales = JSON.parse(popup.querySelector('[data-ebl-ventas]').textContent); } catch (e) {}
      if (!sales.length) return;
      var nameEl = popup.querySelector('[data-ebl-nombre]');
      var cityEl = popup.querySelector('[data-ebl-ciudad]');
      var productEl = popup.querySelector('[data-ebl-producto]');
      var timeEl = popup.querySelector('[data-ebl-tiempo]');
      var verbEl = popup.querySelector('[data-ebl-verbo]');
      var starsEl = popup.querySelector('[data-ebl-estrellas]');
      var commentEl = popup.querySelector('[data-ebl-comentario]');
      var imageEl = popup.querySelector('[data-ebl-imagen]');
      var closeBtn = popup.querySelector('[data-ebl-cerrar]');
      var currentIndex = 0, isClosed = false;
      var visible = num(popup, 'data-visible', 6000), intervalo = num(popup, 'data-intervalo', 10000), espera = num(popup, 'data-espera', 2500);
      function renderSale(item) {
        nameEl.textContent = item.name; cityEl.textContent = item.city;
        productEl.textContent = item.product; timeEl.textContent = item.time;
        if (verbEl && item.verb != null) verbEl.textContent = item.verb;
        if (starsEl) starsEl.textContent = item.stars || '';
        if (commentEl) commentEl.textContent = item.comment ? '\u201C' + item.comment + '\u201D' : '';
        if (item.image) imageEl.src = item.image;
      }
      function showPopup() {
        if (isClosed) return;
        renderSale(sales[currentIndex]);
        popup.classList.add('is-visible');
        clearTimeout(popup.__eblHide);
        popup.__eblHide = setTimeout(function () { popup.classList.remove('is-visible'); }, visible);
        currentIndex = (currentIndex + 1) % sales.length;
      }
      popup.__eblClose = function () {
        isClosed = true; popup.classList.remove('is-visible');
        clearTimeout(popup.__eblHide); clearInterval(popup.__eblInt);
      };
      closeBtn.addEventListener('click', popup.__eblClose);
      popup.__eblStart = setTimeout(function () { showPopup(); popup.__eblInt = setInterval(showPopup, intervalo); }, espera);
    },
    destroy: function (popup) {
      clearTimeout(popup.__eblStart); clearTimeout(popup.__eblHide); clearInterval(popup.__eblInt);
      popup.classList.remove('is-visible');
    }
  });
})();
